import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import clsx from 'clsx';


const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
renderer.link = (href, title, text) => {
  const html = linkRenderer.call(renderer, href, title, text);
  return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
};


const Label = ({ children, htmlFor, className, required, ...props }) => (
  <label
    className={clsx(
      className,
      'text-black block mb-1 font-medium',
      required && 'after:content-["*"] after:ml-0.5'
    )}
    htmlFor={htmlFor}
    {...props}
    dangerouslySetInnerHTML={{ __html: marked.parseInline(children, { renderer }) }}
  />
);

Label.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  htmlFor: PropTypes.string,
};

Label.defaultProps = {
  htmlFor: '',
};

export default Label;
